import { useQuery } from '@tanstack/react-query'
import { trainingService } from '../services/trainingService'

export default function useGetTrainingById(trainingId: string) {
  return useQuery({
    queryKey: ['training', trainingId],
    queryFn: () => trainingService.getTrainingById(trainingId),
  })
}
